module.exports = __webpack_public_path__ + "static/47-future-of-work-20-ways-work-will-change-in-2020-48942d2cc4a4eec108148b97e7081f23.png";